"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSeveralBedrooms = function SvgSeveralBedrooms(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5A1.5 1.5 0 0 0 .5 14v4.027a.5.5 0 0 0 .5.5h18.033a.5.5 0 0 0 .5-.5V14a1.5 1.5 0 0 0-1.5-1.5H2z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 18h3v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1zm15 0h3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4D4D4D",
    x: 4.5,
    y: 10.5,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4D4D4D",
    x: 10.5,
    y: 10.5,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Backpack-Bold, Backpack",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 8
  }, '2+')), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    d: "M5.514 6.034H3v6.051M15.5 6H18v6.065"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSeveralBedrooms);
var _default = exports["default"] = Memo;